import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { Trash2 } from "lucide-react";
import { ConfirmButton, timeAgo } from "./AdminShared";

export default function PostsTab({ posts, onDelete }) {
  if (posts.length === 0) {
    return <div className="card-surface p-8 text-center text-sm text-zinc-500">No posts.</div>;
  }
  return (
    <div className="space-y-2">
      {posts.map((p) => (
        <div key={p.id} data-testid={`admin-post-${p.id}`} className="card-surface p-4">
          <div className="flex items-center gap-3 mb-2 text-xs text-zinc-500">
            <Avatar className="w-6 h-6"><AvatarImage src={p.author.avatar_url} /><AvatarFallback>{p.author.handle?.[0]}</AvatarFallback></Avatar>
            {p.author.display_name} · {timeAgo(p.created_at)} ago
            {p.community && <span className="text-rose-500">· {p.community.name}</span>}
            <span className="ml-auto flex items-center gap-3">
              <span>❤ {p.likes_count}</span>
              <span>🎁 {p.gifts_count}</span>
            </span>
          </div>
          <div className="text-sm text-zinc-100 leading-relaxed break-words">{p.text}</div>
          {p.media_url && <img src={p.media_url} alt="" className="mt-2 max-h-40 object-cover border border-white/5" />}
          <div className="mt-3 flex justify-end">
            <ConfirmButton
              testid={`admin-post-${p.id}-delete`}
              variant="danger"
              label="Delete this post?"
              description="This action is irreversible."
              onConfirm={() => onDelete(p.id)}
            >
              <Trash2 size={13} /> Delete
            </ConfirmButton>
          </div>
        </div>
      ))}
    </div>
  );
}
